module.exports = __webpack_public_path__ + "img/fair-3.cf98ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/fair-3.png
// module id = 1151
// module chunks = 1